/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ResetCognitiveAttempts$Plain$Params {
  companyId: string;
  email?: string;
}

export function resetCognitiveAttempts$Plain(http: HttpClient, rootUrl: string, params: ResetCognitiveAttempts$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, resetCognitiveAttempts$Plain.PATH, 'post');
  if (params) {
    rb.path('companyId', params.companyId, {});
    rb.query('email', params.email, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

resetCognitiveAttempts$Plain.PATH = '/cognitiveAssessment/{companyId}/resetAttempts';
